define('helper/textParser',[],
    function () {

        return {
            toHtml: toHtml
        };

        function toHtml(s) {
            var results = [], re = /{([^}]+)}/g, text;

            while (text = re.exec(s)) {
                results.push(parseLink(text[1]));
            }

            var r = s;
            _.map(results, function (itm) {
                r = r.replace(itm.key, itm.value);
            });

            return r;
        }

        function parseLink(s) {
            var result = {
                key: '{' + s + '}',
                value: '{' + s + '}'
            };
            
            try {
                var p = s.split('|');

                if (p) {
                    p[0] = p[0] || ""; p[0] = p[0].trim();
                    p[1] = p[1] || ""; p[1] = p[1].trim();
                    p[2] = p[2] || ""; p[2] = p[2].trim();

                    var href = 'href="' + p[1] + '"';

                    if (p[1].length > 1 && p[1].substring(0, 1) == "#") {
                        var id = p[2] == '' ? 'class="a-route"' : '';

                        result.value = '<a ' + href + ' ' + id + '>' + p[0] + '</a>';
                    }
                    else {
                        var target = p[2] != '' ? 'target="' + p[2] + '"' : '';

                        result.value = '<a ' + href + ' ' + target + '>' + p[0] + '</a>';
                    }
                }

                return result;
            } catch (ex) {
                return result;
            }
        }
    });
